import {
  params, arrayOf, string, fragment, shape, bool, extend, customType
} from '@thd-nucleus/data-sources';
import { AnchorLinks } from '@thd-olt-component-react/anchor-links';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { ComponentSelector } from '@thd-olt-component-react/component-selector';
import { EmtLinks } from '@thd-olt-component-react/emt-links';
import { Hero } from '@thd-olt-component-react/hero';
import { Resource } from '@thd-olt-component-react/resource';
import { SideNavigation } from '@thd-olt-component-react/side-navigation';
import { Spotlight, SpotlightContainer } from '@thd-olt-component-react/spotlight';
import { MedioInline } from '@thd-olt-component-react/internal-marketing-banner';
import { ContentAccordion } from '@thd-olt-component-react/content-accordion';
import { SpotlightRichText } from '@thd-olt-component-react/spotlight_rich_text';

ComponentSelector.dataModel = {
  component: params({
    id: string().isRequired(),
    componentClass: customType('ComponentClass').enum(['ComponentSelector']).isRequired(),
  }).shape({
    ComponentSelector: fragment().shape({
      id: string(),
      targetingType: shape({
        AdobeTarget: fragment().shape({
          id: string(), mbox: string()
        }),
        MultiArmBandit: fragment().shape({
          id: string(), campaignId: string()
        })
      }),
      defaultComponent: arrayOf(shape({
        ...Hero.dataModel.component, ...Spotlight.dataModel.component, ...Resource.dataModel.component,
      })),
      variations: arrayOf(shape({
        ...Hero.dataModel.component, ...Spotlight.dataModel.component, ...Resource.dataModel.component,
      })),
    }),
  }),
};

const giftCardLayoutDataModel = fragment().shape({
  id: string(),
  heroCarousel: shape({
    id: string(),
    isCarousel: bool(),
    isAutoplay: bool(),
    components: arrayOf(shape({
      ...Hero.dataModel.component, ...ComponentSelector.dataModel.component
    })),
  }),
  spotlightSection: shape({
    id: string(),
    isCarousel: bool(),
    isAutoplay: bool(),
    components: arrayOf(shape({
      ...SpotlightRichText.dataModel.component,
      ...Spotlight.dataModel.component,
      ...SpotlightContainer.dataModel.specializedContainer,
      ...ComponentSelector.dataModel.component
    })),
  }),
  medioInline: shape({ ...MedioInline.dataModel.component }),
  carouselBanner: shape({
    id: string(),
    isCarousel: bool(),
    isAutoplay: bool(),
    components: arrayOf(shape({
      ...MedioInline.dataModel.component,
    })),
  }),
  descriptionNew: shape({
    title: string(), descriptionText: string(), description: string()
  }),
  seoLinks: shape({
    id: string(),
  }),
  contentAccordion: arrayOf(shape({ ...ContentAccordion.dataModel.component })),
  linkPills: shape({ ...AnchorLinks.dataModel.component }),
});

const breadCrumbsDataModel = fragment().shape({
  __typename: string(),
  breadcrumbItem: shape({
    BreadcrumbItem: fragment().shape({
      label: string(), url: string()
    })
  })
});

const seoDataModel = shape({
  canonicalURL: string(),
  description: string(),
  facebookAdmins: string(),
  siteName: string(),
  title: string(),
  type: string(),
  linkData: string(),
  scriptData: string(),
  no_index: string(),
  no_follow: string()
});

export const giftCardDataModel = extend({
  layouts: params({
    slug: string().isRequired(), customerType: string()
  }).shape({
    slug: string(),
    title: string(),
    type: string(),
    breadcrumbs: shape({
      __typename: string(), Breadcrumbs: breadCrumbsDataModel
    }),
    seo: seoDataModel,
    content: shape({
      __typename: string(),
      GiftCardLayout: giftCardLayoutDataModel
    }),
  }),
},
// you need this here too because the query is asked for at the root level
Breadcrumbs, ComponentSelector, EmtLinks, MedioInline, Hero, // GiftCardsList,
Resource, SideNavigation, Spotlight, SpotlightRichText, SpotlightContainer, ContentAccordion, AnchorLinks);
